import { get } from "helpers/api_helper"
import {
  normalizeAdminListFilters,
  normalizeAdminListOptions,
} from "helpers/adminListQueryPolicy"

export const getTransactions = async (filter, options) => {
  const filters = new URLSearchParams({
    ...normalizeAdminListFilters(filter),
    ...normalizeAdminListOptions(options),
  }).toString()
  return get(`/admin/payments?${filters}`, { timeout: 15000 })
}
